import { Reference } from '.';

export class DocumentReference {
    id?: string;
    reference: Reference;
    displayName: string;
}
